import { QueryClientProvider } from '@tanstack/react-query'
import { ConfigProvider } from 'antd'
import viVN from 'antd/locale/vi_VN'
import { useEffect } from 'react'
import { Provider, useSelector, useDispatch } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { localeActions } from 'reactjs-tiptap-editor/locale-bundle'
import { PersistGate } from 'redux-persist/integration/react'

import { queryClient } from '@/api/queryClient'
import { getTheme } from '@/config/theme.config'
import { ErrorBoundary } from '@/features/gamefi/components/ErrorBoundary'
import { router } from '@/routes'
import { store, persistor, RootState } from '@/store'
import { syncAuthState } from '@/store/slices/authSlice'
import '@/i18n/config'

// Inner component to access Redux state
function ThemedApp() {
  const dispatch = useDispatch()
  const themeMode = useSelector((state: RootState) => state.theme.mode)
  const currentTheme = getTheme(themeMode)

  // Sync auth state with localStorage on mount
  useEffect(() => {
    localeActions.setLang('vi')
    dispatch(syncAuthState())
  }, [dispatch])

  return (
    <ConfigProvider theme={currentTheme} locale={viVN}>
      <RouterProvider router={router} />
    </ConfigProvider>
  )
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary>
            <ThemedApp />
          </ErrorBoundary>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
